<script>
    import Project from './Project.svelte';

    const projects = [
        {
            title: 'Assayo Marketplace (in progress)',
            image: '/assets/assayo.png',
            description: 'Built a full-stack role-based marketplace with SvelteKit/TypeScript and PostgreSQL, featuring secure Argon2id authentication, real-time logging, and custom email infrastructure. Designed relational schema for multi-role users and integrated Stripe API for secure payments with automated checkout verification. Delivered responsive dashboard with Tailwind CSS, search/filter marketplace, and end-to-end testing (Playwright), deployed via Docker/Vercel with CI/CD.',
            github: '',
            imagePosition: 'left',
            date: 'Summer 2025',
            languages: 'SvelteKit, TypeScript, PostgreSQL, Stripe, Docker, Vercel',
            link: 'https://www.assayo.com/',
            backupLink: 'https://assayo.vercel.app/'
        },
        {
            title: 'Zombs Multiplayer Client (in progress)',
            image: '/assets/zombs-client.png',
            description: 'Built real-time WebSocket multiplayer system with binary protocols, authoritative server physics, and custom ECS for synchronized game state. Developed Three.js + Rapier3D engine with rendering, lighting, camera controls, realistic collisions, and dynamic block-world interactions. Delivered modular full-stack game platform using TypeScript, Vite, and Vercel, with shared client/server code and custom Python-based map editor.',
            github: '',
            imagePosition: 'left',
            date: 'Spring 2025',
            languages: 'TypeScript, WebSocket, Three.js, Rapier3D, Python, Vite',
            link: 'https://zombs-client.vercel.app/'
        },
        {
            title: 'Zombs 3D FPS Game',
            image: '/assets/zombsarena.png',
            description: 'Built a 3D FPS in vanilla JavaScript (3,000+ lines) with Three.js/WebGL for rendering, lighting, and scene management. Implemented collision detection, raycasting, AI pathfinding, and physics-based projectiles with optimized rendering. Developed responsive UI with animations, audio, settings persistence, and modular ES6 architecture.',
            github: '',
            imagePosition: 'right',
            date: 'Spring 2025',
            languages: 'JavaScript, Three.js, WebGL, ES6',
            link: 'https://zombs.tech/',
            backupLink: 'https://zombiearena.vercel.app/'
        },
        {
            title: 'Secret Santa Generator',
            image: '/assets/nick.png',
            description: 'secret santa gift for friend, Merry Christmas!',
            github: '',
            imagePosition: 'left',
            date: 'Fall 2024',
            languages: 'Svelte, Canvas API, JavaScript, CSS',
            link: 'https://nick-secret-santa.vercel.app/'
        },
        {
            title: 'ACM Website',
            image: '/assets/acm-website.jpg',
            description: 'As the Senior Web Developer for ACM@UMD, I developed the website (acm-umd.com) using Svelte. I integrated Google Analytics for traffic insights, implemented SEO strategies, and ensured a fully responsive design. Additionally, I managed continuous integration and deployment via Vercel, enhancing engagement.',
            github: 'https://github.com/acm-umd/umdwebsite',
            imagePosition: 'right',
            date: 'September 2024',
            languages: 'Svelte, JavaScript, CSS, HTML',
            link: "https://www.acm-umd.com/",
            backupLink: "https://acm-umd.vercel.app/"
        },
        {
            title: "Chicken Learn",
            image: "/assets/Chicken-learn.jpg",
            description: "Chicken Learn is an interactive web platform to make vocabulary building fun for children through 3D elements and animations. Built with Svelte and JavaScript, it features a user-friendly interface for exploring new words from the Random Word Generator API and definitions from DictionaryAPI. The platform includes dynamic visuals and custom CSS animations, all of which I designed without using templates.",
            github: "https://github.com/JoshuaZheng0/chicken-learn",
            imagePosition: "left",
            date: "October 2024",
            languages: "Svelte, JavaScript, CSS, HTML, Spline, DictionaryAPI",
            link: "https://chicken-learn.vercel.app/"
        },
        {
            title: 'Library Room Scraper',
            image: '/assets/library.jpg',
            description: 'The McKeldin Library at UMD is often crowded, making it hard for students to find available study rooms, so I created a Selenium Python script to automate room reservations, allowing users to secure study rooms up to a week in advance. This makes it easier for students to find available spaces.',
            github: 'https://github.com/JoshuaZheng0/library-reservation-scraper',
            imagePosition: 'right',
            date: 'September 2024',
            languages: 'Python, Selenium'
        },
        {
            title: 'Tesla Stock Price Predictor',
            image: '/assets/tesla.jpg',
            description: 'Developed an LSTM-based model to predict Tesla stock prices using Pandas, Numpy, and Keras. Integrated RSI indicators and evaluated performance with R-squared, max error, and variance metrics. Visualized prediction results with Matplotlib and web scraped data from Yahoo Finance using BeautifulSoup.',
            github: 'https://github.com/JoshuaZheng0/Tesla-Stock-Price-Prediction-Model',
            imagePosition: 'left',
            date: 'Summer 2023',
            languages: 'Python, Numpy, pandas, Plotly, BeautifulSoup'
        },
        {
            title: 'Drone Imaging and Interactive Tour Developer',
            image: '/assets/hl.jpg',
            description: 'Worked for the former Vice President of Warner Brothers to capture hundreds of aerial images with a drone and developed them into 360° photos using Photoshop. Created a 52-scene virtual walkthrough with Cloudpano and integrated the tour into a professional website.',
            github: '',
            imagePosition: 'right',
            date: 'May 2024–August 2024',
            languages: 'Photography, Photoshop, Drone Piloting',
            link: 'https://app.cloudpano.com/tours/nrUoBcJQb'
        },
        {
            title: "Debian Home Server (shut down)",
            image: "/assets/VPS.jpg",
            description:"I configured a Debian server (migrated it to a VPS) for hosting web applications. Set up NGINX for web hosting, implemented secure SSH access, and firewall rules for enhanced security. I used DuckDNS to obtain a free domain and secured traffic with CertBot, which automatically configures and renews SSL certificates for HTTPS. The server follows best security practices, with SSH key access for both root and the subuser joshlocal, and a firewall managed by ufw to prevent unauthorized access.",
            github: "",
            imagePosition: "left",
            date: "Summer 2024",
            languages: "Linux, Debian, NGINX, SSH",
            link: "https://vps.joshuazheng.lol/"
        },
        {
            title: 'Gambling Simulation Game',
            image: '/assets/gambling.png',
            description: 'Created a 2D slots game featuring a graphical interface using Unity and C#. The game includes engaging gameplay mechanics and a user-friendly design.',
            github: 'https://www.youtube.com/watch?v=sQOKUArmOCY',
            imagePosition: 'right',
            date: 'Spring 2024',
            languages: 'Unity, C#'
        }
        
    ];
</script>

<div class="projects-section">
    <div class="section-header">
        <h1 class="projects-title">Featured Projects</h1>
        <p class="projects-subtitle">A showcase of my recent work and technical expertise</p>
    </div>
    <div class="projects-grid">
        {#each projects as project}
            <Project 
                title={project.title} 
                image={project.image} 
                description={project.description} 
                github={project.github} 
                imagePosition={project.imagePosition}
                date={project.date}
                languages={project.languages}
                link={project.link}
                backupLink={project.backupLink}
            />
        {/each}
    </div>
</div>

<style>
    .projects-section {
        padding: 1.5rem 0;
        max-width: 1200px;
        margin: 0 auto;
    }

    .section-header {
        text-align: center;
        margin-bottom: 1.5rem;
    }

    .projects-title {
        font-size: 3rem;
        font-weight: 700;
        margin: 0 0 1rem 0;
        background: linear-gradient(135deg, #64b5f6, #42a5f5);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        line-height: 1.2;
    }

    .projects-subtitle {
        font-size: 1.2rem;
        color: #b0b0b0;
        margin: 0;
        font-weight: 400;
    }

    .projects-grid {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
    }

    @media only screen and (max-width: 768px) {
        .projects-section {
            padding: 1.5rem 0;
        }

        .projects-title {
            font-size: 2.5rem;
        }

        .projects-subtitle {
            font-size: 1.1rem;
        }

        .section-header {
            margin-bottom: 1.5rem;
        }
    }
</style>
